import * as React from "react";
import { SVGProps, memo } from "react";
const SvgWarningHighSeverity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      fill="#FECA63"
      d="M1.1 12 6.8 1.8c.3-.6 1-.6 1.4 0L13.9 12c.3.6-.1 1.3-.8 1.3H1.9c-.6 0-1.1-.7-.8-1.3z"
    />
    <path fill="#333" d="M6.7 10.1h1.6v1.6H6.7zM6.7 4.5h1.6v4.8H6.7z" />
  </svg>
);
const Memo = memo(SvgWarningHighSeverity);
export default Memo;
